import { sensorsParams } from '../env'

export const apiClientHeader = {
    client: sensorsParams.client,
    channel: sensorsParams.channel
}